function alertParameterProductCategoryController(alertsFrameworkService, productsService) {
	const $ctrl = this;

	$ctrl.areProductCategoriesLoading = false;

	$ctrl.$onInit = function () {
		loadProductCategories();

		$ctrl.productCategoryKeys = alertsFrameworkService.getKeyArrayFromCsv($ctrl.model);
	};

	/* Handle Model Changes on the Parent */
	$ctrl.$onChanges = function(changes) {
		if (changes.model){
			const newKeys = alertsFrameworkService.getKeyArrayFromCsv(changes.model.currentValue);
			const arraysEqual = 
				newKeys.length === $ctrl.productCategoryKeys.length 
				&& newKeys.every((value, index) => value === $ctrl.productCategoryKeys[index]);

			if (!arraysEqual)
			{
				$ctrl.productCategoryKeys = newKeys;
			}        
		}		
    }

	$ctrl.productCategoriesChanged = (item, model) => {
        const csvValue = alertsFrameworkService.getCsvFromKeyArray($ctrl.productCategoryKeys);
		
		$ctrl.onUpdate({csvValue: csvValue});
	};

	function loadProductCategories() {
		$ctrl.areProductCategoriesLoading = true;

		return productsService
			.getProductCategoryReports($ctrl.subscriberKey)
			.then((productCategories) => {
				$ctrl.productCategories = productCategories.toSorted((a, b) => {
                    const nameA = a.productCategoryReportName.toUpperCase();
                    const nameB = b.productCategoryReportName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    }

                    if (nameA > nameB) {
                        return 1;
                    }

                    return 0;
                });
                
				$ctrl.areProductCategoriesLoading = false;
			});
	}
}

angular
	.module("angus.components")
	.component("alertParameterProductCategory", {
		controller: alertParameterProductCategoryController,
		bindings: {
			subscriberKey: "<",
			label: "<",
			model: "<",
			isReadOnly: "<",
			onUpdate: "&"
		},
		template: `
<label class="control-label" for="productCategories">{{$ctrl.label || 'Product Category'}}
    <i class="fa fa-spinner fa-spin" data-fade-toggle="areProductCategoriesLoading"></i></label>

<ui-select
    class="alert-select" 
	multiple 
	ng-model="$ctrl.productCategoryKeys" 
	ng-disabled="!$ctrl.productCategories.length || $ctrl.isReadOnly" 
	on-select="$ctrl.productCategoriesChanged($item, $model)" 
	on-remove="$ctrl.productCategoriesChanged($item, $model)"
>
    <ui-select-match placeholder="Select product categories...">{{$item.productCategoryReportName}}</ui-select-match>
    <ui-select-choices repeat="productCategory.productCategoryReportKey as productCategory in $ctrl.productCategories | filter: {productCategoryReportName: $select.search}">
        {{productCategory.productCategoryReportName}}</ui-select-choices>
</ui-select>
		`
	});
